import { useGlobalContext } from "../../contexts/GlobalContext";
import { getConvs, getLeads } from "../../queries/conv";
import {
    getAllLeadsCount,
    getAllLeadsCountLast30Days,
} from "../../queries/mentor";
import { useEffect, useState } from "react";
import { getDashboardSummary } from "../../queries/dashboard";

const GetStatsData = () => {
    const [leadsCount, setLeadsCount] = useState(null);
    const [leadsCountLast30Days, setLeadsCountLast30Days] = useState(null);
    const [totalMessageExchange, setTotalMessageExchange] = useState(null);
    const [summaryData, setSummaryData] = useState(null);

    const [state] = useGlobalContext();
    const privilege = state.user?.privilege;

    const fetchSummaryData = async () => {
        const data = await getDashboardSummary();
        if (!data) return null;

        if (Array.isArray(data)) return data;

        if (typeof data === 'string') {
            const csvLines = data.trim().split('\n');
            return csvLines.map(line => {
                const fields = [];
                let current = '';
                let inQuotes = false;
                for (let i = 0; i < line.length; i++) {
                    const char = line[i];
                    if (char === '"') { inQuotes = !inQuotes; }
                    else if (char === ',' && !inQuotes) { fields.push(current); current = ''; }
                    else { current += char; }
                }
                fields.push(current);
                return {
                    firstName: fields[0]?.replace(/"/g, '') || '',
                    lastName: fields[1]?.replace(/"/g, '') || '',
                    email: fields[2]?.replace(/"/g, '') || '',
                    phone: fields[3]?.replace(/"/g, '') || '',
                    year: fields[6]?.replace(/"/g, '') || '',
                    type: fields[7]?.replace(/"/g, '') || '',
                    createdAt: fields[8]?.replace(/"/g, '') || ''
                };
            });
        }

        return null;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [AllLeadsData, Last30DaysData, rawLeadData, summaryData] =
                    await Promise.all([
                        getAllLeadsCount(),
                        getAllLeadsCountLast30Days(),
                        getLeads(),
                        fetchSummaryData(),
                    ]);

                setLeadsCount(AllLeadsData);
                setLeadsCountLast30Days(Last30DaysData);
                setTotalMessageExchange(rawLeadData);
                setSummaryData(summaryData);
            } catch (error) {
                console.error("Error fetching leads count:", error);
            }
        };

        fetchData();
    }, []);

    const calculateAllLeads = () => {
        if (summaryData && Array.isArray(summaryData)) {
            // console.log("Total leads from summary data:", summaryData.length);
            return summaryData.length;
        }
        
        // Fallback to existing calculation if summary data doesn't work
        if (totalMessageExchange && totalMessageExchange.leads) {
            // console.log("Using fallback - totalMessageExchange.leads.length:", totalMessageExchange.leads.length);
            return totalMessageExchange.leads.length;
        }
        
        // console.log("No data found, returning 0");
        return 0;
    };
    const calculateTotalMessageExchanges = () => {
        let totalCount = 0;

        if (totalMessageExchange && totalMessageExchange.leads) {
            for (let i = 0; i < totalMessageExchange.leads.length; i++) {
                totalCount += totalMessageExchange.leads[i].messages.length;
            }
        }
        return totalCount;
    };
    const calculateLast30DaysLeads = () => {
        if (summaryData && Array.isArray(summaryData)) {
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
            
            const filtered = summaryData.filter(lead => {
                const createdDate = new Date(lead.createdAt);
                return createdDate >= thirtyDaysAgo;
            });
            
            // console.log("Last 30 days leads count:", filtered.length);
            return filtered.length;
        }
        
        // Fallback to existing data
        if (totalMessageExchange && totalMessageExchange.leads) {
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
            
            const filtered = totalMessageExchange.leads.filter(lead => {
                const createdDate = new Date(lead.createdAt);
                return createdDate >= thirtyDaysAgo;
            });
            
            // console.log("Fallback - Last 30 days leads count:", filtered.length);
            return filtered.length;
        }
        
        // console.log("No data for last 30 days, returning 0");
        return 0;
    };

    const arr = [
        {
            title: "TOTAL LEADS",
            count:
                privilege === "Magnolia"
                    ? "3024"
                    : calculateAllLeads()
                    ? calculateAllLeads().toString()
                    : "0",
            // percentageChange:"26%",
        },
        {
            title: "LEADS IN LAST 30 DAYS",
            count:
                privilege === "Magnolia"
                    ? "1005"
                    : calculateLast30DaysLeads().toString(),
            // percentageChange:"14%",
        },
        {
            title: "MESSAGES",
            count:
                privilege === "Magnolia"
                    ? "5201"
                    : calculateTotalMessageExchanges().toString(),
            // percentageChange:"29%",
        },
        {
            title: "WIDGET INTERACTIONS",

            count:
                privilege === "GW Law"
                    ? "789"
                    : privilege === "usc"
                    ? "2982"
                    : privilege === "Dickinson"
                    ? "598"
                    : privilege === "Magnolia"
                    ? "8467"
                    : "0",
            // percentageChange:"40%",
        },
    ];

    return arr;
};

export default GetStatsData;
